import { render } from "./RestoreBtn.vue?vue&type=template&id=e33e3f98&ts=true"
import script from "./RestoreBtn.vue?vue&type=script&lang=ts"
export * from "./RestoreBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__